module.exports = __webpack_public_path__ + "static/media/S (159).6bf28b69.jpg";